<template>
  <div>
    <PageAllow controller="StockTakes" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('StockTakeOrders.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <!-- 盘点计划单 -->
            <v-btn
              v-if="$permission.permissionAllow('ShopStockTakePlans', 'index')"
              small
              color="primary"
              href="/#/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans"
              class="ms-1"
            >
              <!-- /stock-take-orders/detail -->
              <v-icon x-small class="pe-1">fa-clipboard-list</v-icon>
              {{
                  $t("shopStockTakePlans.objectName"),
              }}
            </v-btn>
            <!-- 新增库位批次盘点单 -->

            <v-btn
              v-if="
                settings &&
                settings.stock_position_setting &&
                $permission.permissionAllow('StockTakes', 'add')
              "
              small
              color="primary"
              href="/#/stock-take-orders/new"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{
                $t("CRUD.newInfo", [
                  $t("StockTakeOrders.positionStockStakeOrder"),
                ])
              }}
            </v-btn>
            <!-- 新增普通盘点单 -->
            <v-btn
              v-if="
                settings &&
                (!settings.stock_position_setting ||
                  settings.material_position_bind ||
                  settings.stock_common_take) &&
                $permission.permissionAllow('StockTakes', 'add')
              "
              small
              color="primary"
              href="/#/stock-take-orders/regular-new"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{
                $t("CRUD.newInfo", [
                  $t("StockTakeOrders.actions.regularStockTakeOrder"),
                ])
              }}
            </v-btn>
            <!-- 新增批次盘点单 -->
            <v-btn
              v-if="
                settings &&
                !settings.stock_position_setting &&
                $permission.permissionAllow('StockTakes', 'add')
              "
              small
              color="primary"
              href="/#/stock-take-orders/batch-new"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{
                $t("CRUD.newInfo", [
                  $t("StockTakeOrders.actions.batchStockTakeOrder"),
                ])
              }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_take_code"
                  v-model="options.stock_take_code"
                  @text="stockTakeKeyWord = $event"
                  :label="$t('StockTakeOrders.stockTakeKeyWord')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock v-model="stocksSelected" :stock-types="[0]" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :items="$consts.stockTakeOrder.status"
                  :label="$t('StockTakeOrders.orderStatus.title')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_take_orders"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.stock_take_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_take_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | stockTakeOrderStatusColor"
              :text-color="item.status | stockTakeOrderStatusTextColor"
            >
              {{ item.status | stockTakeOrderStatusText }}
            </v-chip>
            <br />
            <v-chip v-if="item.cancel_flg" x-small label outlined color="danger"
              >{{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <StockTakeOrderActions
              :stock_take_order="item"
              showView
              :showStockTake="item.actions.stock_take"
              :showCancel="item.actions.cancel"
              showExport
              @done="getStockTakeOrdersFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import StockTakeOrders from "@/api/stock_take_orders";
import StockTakeOrderActions from "./plugins/Actions";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_ids: null,
  status: [1],
  cancel_flgs: [0],
  stock_take_code: "",
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherStock,
    SearcherStatus,
    SearcherCancelFlgs,
    StockTakeOrderActions,
    SearcherKeyword,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        replace: true,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stockTakeOrders"),
        disabled: true,
        href: "/stock-take-orders",
      },
    ],
    headers() {
      return [
        {
          text:
            i18n.t("StockTakeOrders.Fields.order_code") +
            " / " +
            i18n.t("StockTakeOrders.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_take_code",
        },
        {
          text: i18n.t("StockTakeOrders.Fields.stock_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "stock.name",
        },
        {
          text: i18n.t("StockTakeOrders.Fields.categories_total"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "type_count",
        },
        {
          text: i18n.t("StockTakeOrders.Fields.operater_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "operater_name",
        },
        {
          text: i18n.t("StockTakeOrders.orderStatus.title"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    importBtnMenu: false,
    stocksSelected: null,
    stock_take_orders: [],
    datetimeRage: [
      new Date(new Date().getTime() -7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    options: JSON.parse(
      sessionStorage.getItem("stock-take-orders-options")
        ? sessionStorage.getItem("stock-take-orders-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    detailMode: false,
    btnPrintMenu: false,
    btnExportMenu: false,
    stockTakeKeyWord: "",
  }),

  mounted() {
    this.$commonUtils.loadOptions("stock-take-orders", ["stocksSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
          if (
            typeof this.options.created_time_from != "undefined" &&
            typeof this.options.created_time_to != "undefined"
          )
            this.datetimeRage = [
              this.options.created_time_from,
              this.options.created_time_to,
            ];
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stocksSelected":
              this.stocksSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  methods: {
    resetSearch() {
      this.stocksSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.getStockTakeOrdersFromAPI();
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_take_code: this.stockTakeKeyWord,
      });
    },
    getStockTakeOrdersFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      StockTakeOrders.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_take_orders = response.data.stock_take_histories;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockTakeOrdersFromAPI();
        sessionStorage.setItem(
          "stock-take-orders-options",
          JSON.stringify(this.options)
        );
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.id
          : "";
        sessionStorage.setItem(
          "stock-take-orders-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() -7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>